import React from 'react'
import { MenuProps } from 'components/menu'
import FloatingMenu from 'components/menu/floating'
import { MenuItem, MenuList } from 'components/menu/items'
import { SmallRowHeight, MediumRowHeight, TallRowHeight, ExtraTallRowHeight, Tick } from 'components/icons'
import { useDataContext } from 'components/spreadsheet/contexts/data/useDataContext'

// How tall the view's rows are: one of four heights, each a menu row with its own drawing of the
// height, and a tick on the one in use. Picking one sets it and closes.

const HEIGHTS = [
  { value: 0, label: 'Small', icon: <SmallRowHeight /> },
  { value: 1, label: 'Medium', icon: <MediumRowHeight /> },
  { value: 2, label: 'Tall', icon: <TallRowHeight /> },
  { value: 3, label: 'Extra tall', icon: <ExtraTallRowHeight /> }
]

const RowHeightMenu: React.FC<MenuProps> = ({ id, menuState, setMenuState, width }) => {
  const { spreadsheetData, setSpreadsheetData } = useDataContext()
  const current = spreadsheetData.viewDetails.rowHeight

  // Stays open, as a floating panel does on a pick, so a misclick is put right in place.
  const pick = (newRowHeight: number) => {
    if (newRowHeight !== current) setSpreadsheetData({ type: 'CHANGE_ROW_HEIGHT', newRowHeight })
  }

  return (
    <FloatingMenu
      id={id}
      menuState={menuState}
      setMenuState={setMenuState}
      width={width}
      zIndex={3000}
      title="Row height"
    >
      <MenuList>
        <div role="menu" aria-label="Row height" className="flex flex-col">
          {HEIGHTS.map((height) => (
            <MenuItem
              key={height.value}
              role="menuitemradio"
              aria-checked={height.value === current}
              icon={height.icon}
              onClick={() => pick(height.value)}
              end={height.value === current ? <Tick className="size-4 text-body" /> : undefined}
            >
              {height.label}
            </MenuItem>
          ))}
        </div>
      </MenuList>
    </FloatingMenu>
  )
}

export default RowHeightMenu
